var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangle5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 881,
    height: 941,
    viewBox: "0 0 881 941",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 360.963,
    y: -139,
    width: 760.889,
    height: 1579.93,
    rx: 380.445,
    transform: "rotate(30 360.963 -139)",
    fill: "#F5E6F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle5);
export default __webpack_public_path__ + "static/media/Rectangle 5.8dd7ef97411e7c3eaee3ae0e38442039.svg";
export { ForwardRef as ReactComponent };